// Специальности медработников (средний медперсонал)
export const nursingSpecialties = [
  { value: 'nurse', label: 'Медицинская сестра / брат' },
  { value: 'feldsher', label: 'Фельдшер' },
  { value: 'midwife', label: 'Акушерка' },
  { value: 'lab_technician', label: 'Лаборант' },
  { value: 'nursing_other', label: 'Другая специальность' },
]
